import Swiper, { Navigation } from 'swiper';

class Gallery {
  constructor(el, options = {}) {
    this.el = el;
    this.options = {
      ...options,
    };
  }

  init() {
    this.swiper = new Swiper(this.el, {
      spaceBetween: 10,
      modules: [Navigation],
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }
}

window.LSGallery = Gallery;
